import { render } from "./StatusChip.vue?vue&type=template&id=05d2468a&scoped=true"
import script from "./StatusChip.vue?vue&type=script&lang=js"
export * from "./StatusChip.vue?vue&type=script&lang=js"

import "./StatusChip.vue?vue&type=style&index=0&id=05d2468a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d2468a"]])

export default __exports__